import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Pencil(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M1.099 11.119L4.8 14.882.943 15.993a.844.844 0 01-.937-.952L1.1 11.119zm8.945-8.95L2.4 9.944l3.822 3.887 7.645-7.775m1.24-1.175c1.294-1.316 1.082-2.872 0-3.973-1.083-1.1-2.613-1.316-3.907 0l3.907 3.973z"
  }));
}

export { Pencil };
//# sourceMappingURL=Pencil.js.map